export const fieldsKeys = {
  all: ['fields'] as const,
  locale: () => [...fieldsKeys.all, 'locale'] as const,
  fieldsByLocale: (locale?: string, indexId?: number) => [...fieldsKeys.locale(), locale, indexId] as const,
  fieldTranslations: {
    all: () => [...fieldsKeys.all, 'translations'] as const,
    detail: (indexId?: number, localeId?: number) => [...fieldsKeys.fieldTranslations.all(), indexId, localeId] as const
  }
};
